const favourite_day  = `One of the best days of my life was when my son was born. 
It was a day filled with joy and happiness that I will never forget.
When my son was born, I felt a love that I had never felt before. 
I was so happy to see him and hold him in my arms for the first time. 
It was a special moment that I will always cherish.
Family and friends came to celebrate the special day with us. 
They brought gifts and shared their love and support, which made the day even more memorable and joyful.
I remember the happiness and excitement that filled the room when my son arrived. 
It was a feeling of pure joy and love that I will always hold close to my heart.
The day my son was born was a day filled with love, hope, and new beginnings.
It was a day that changed my life forever and brought so much happiness and meaning to my world.`;

export default favourite_day;